@if (canEdit) {
  <div class="text-center">
    <button mat-icon-button
            (click)="onEditFaqClick()"
            data-testid="edit-faq-button">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
}
